import Select from 'react-select'
import st from './SelectField.module.scss'
import {useRegions} from '../../helpers';

const styles = {
    control: (bs, state) => ({
        ...bs,
        backgroundColor: '#E7F2FE',
    })
}


export const SelectField =({ setRegion, activeItem, menuIsOpen })=> {
    const { data, dataList, isLoading } = useRegions()
    const handleChange = (val) => val !== 0 ? setRegion(val) : setRegion(null)
    const options = (!!data && !!dataList) ? [...dataList?.data?.data?.filter(item => item.active)] : []

    return (
        <div className={st.selector}>
            <Select
                styles={styles}
                options={options}
                value={data?.data?.data?.find(item => item.id === activeItem)}
                placeholder="Поиск ..."
                isClearable
                noOptionsMessage={()=> 'Не найдено.'}
                isLoading={isLoading}
                getOptionLabel={(option)=>option.name}
                getOptionValue={(option)=>option.id}
                onChange={handleChange}
                isSearchable
                menuIsOpen={menuIsOpen}
                classNamePrefix="select-field"
            />
        </div>
    )
}
